import TablaDrivers from "./TablaDrivers";

export default function DriverPygOtrosIngresosContent({ empresaId, ejercicios, aniosProyectar, readOnly }) {
  return (
    <TablaDrivers
      empresaId={empresaId}
      ejercicios={ejercicios}
      seccionPyg="otros_ingresos"
      titulo="Driver de Otros Ingresos (PyG)"
      descripcion="Proyección de partidas de 'Otros ingresos de explotación' (partida 5 del PyG). Los ingresos financieros (76x) se definen en Financiación."
      aniosProyectar={aniosProyectar}
      readOnly={readOnly}
      storageKey={`finreport:nivel:${empresaId}:pyg-otros-ingresos`}
      filtroCodigos={["74", "75", "790", "791", "792", "793", "794"]}
      nivelesPermitidos={["3D", "MAX"]}
    />
  );
}
